<template>
    <b-form-textarea
        :state="input_state"
        :value="value"
        v-bind="$attrs"
        v-on="inputListeners"
    ></b-form-textarea>
</template>

<script>
import VuexInputFieldMixin from "./VuexInputFieldMixin";

export default {
    name: "OTextareaInput",
    mixins: [VuexInputFieldMixin(false)],
};
</script>

<style scoped></style>
